import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import OTPTimer from "../../../Tools/Otptimer";
import OTPInput from "react-otp-input";
import Button from "../../../Tools/Button";
import { setOtp } from "../../../../Reducer/studentSlice";
import {
  changeNumber,
  otpVerification,
  phoneVerification,
  setDeviceToken,
} from "../../../../Reducer/authSlice";
import { firebaseConfig, mediaUrl } from "../../../../services/network";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
const StudentOtp = ({ onHide, setShowPhoneModel, modelViewControll }) => {
  const [otp, setOotp] = React.useState("");
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.auth);
  const userLocation = useSelector((state) => state.auth?.userDetails);
  const normalSelector = useSelector((state) => state.auth);
  const otpDuration = 120; // Adjust the OTP timer duration as needed
  const handleOTPTimerTimeout = () => {
    // You can perform any action you want when the timer expires here.
  };

  const onResendFun = () => {
    const body = {
      phone: selector.phoneNumber,
      latitude: userLocation?.latitude,
      longitude: userLocation?.longitude,
      ip_address: userLocation?.ip_address,
      current_address: userLocation?.address,
      device_token: normalSelector?.deviceToken
        ? normalSelector?.deviceToken
        : localStorage.getItem("guestId"),
      role: 1,
    };
    dispatch(phoneVerification(body));
  };
  const handleSubscribe = async () => {
    try {
      const app = initializeApp(firebaseConfig);
      const messaging = getMessaging(app);
      const requestPermission = () => {
        return new Promise((resolve, reject) => {
          Notification.requestPermission()
            .then((permission) => {
              if (permission === "granted") {
                resolve();
              } else {
                reject(
                  new Error(
                    "Permission denied for receiving push notifications."
                  )
                );
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      };
      const data = await requestPermission()
        .then(() => {
          console.log("Permission granted.");
          return getToken(messaging);
        })
        .then((token) => {
          dispatch(setDeviceToken(token));
          console.log("Token:", token);
        })
        .catch((error) => {
          console.log("Error:", error.message);
        });
    } catch (error) {
      console.log("Error subscribing:", error);
    }
  };
  const onSubmit = (e) => {
    e.preventDefault();
    try {
      const body = {
        phone: selector.phoneNumber,
        otp: otp,
        app_id: 2,
        app_version: "17.05.02",
        platform: "web",
        longitude: 0,
        latitude: 0,
        ip_address: "",
        current_address: "",
        device_token: normalSelector?.deviceToken
          ? normalSelector?.deviceToken
          : localStorage.getItem("guestId"),
        device_id: "435345345",
      };
      dispatch(otpVerification(body));
      if (modelViewControll) {
        modelViewControll();
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (modelViewControll) {
      modelViewControll();
    }
    if (normalSelector.deviceToken == "") {
      handleSubscribe();
    }
  }, [selector.success, selector.otpSuccess, normalSelector.deviceToken]);

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <div className="lest_login text-center">
            <img
              src={`../../assets/images/chownk-logo.png`}
              alt="CHOWNK logo"
            />
            <h3 className="text-center">{"OTP Verification"}</h3>
            <h6>
              {"An OTP has been sent to your"}
              <br />
              {"phone number"}{" "}
              <Link
                onClick={() => {
                  dispatch(changeNumber(""));
                  dispatch(setOtp(""));
                  onHide();
                  setShowPhoneModel();
                }}
              >
                {"Change"}
              </Link>
            </h6>
            <form className="text-start mt-4" onSubmit={onSubmit}>
              <div className="form-group form-groupotp text-center">
                <label className="d-block text-start">
                  {"Enter your OTP"} {selector.otp}
                </label>
                <OTPInput
                  className={"form-control"}
                  inputStyle={{ width: "40px" }}
                  value={otp}
                  onChange={setOotp}
                  numInputs={4}
                  inputType={"tel"}
                  renderSeparator={<span> </span>}
                  renderInput={(props) => <input {...props} />}
                />
                {selector.otpError && (
                  <p style={{ color: "red" }}>{selector.otpError}</p>
                )}
              </div>
              <h5 className="mt-3 text-center">
                <OTPTimer
                  duration={otpDuration}
                  onTimeout={handleOTPTimerTimeout}
                  onResend={onResendFun}
                />
              </h5>
              <Button
                inType={"submit"}
                style={"btn mt-2 mt-lg-5"}
                title={"Continue"}
                inlineStyle={
                  otp.length == 4
                    ? { backgroundColor: "#1DBF73", color: "white" }
                    : {}
                }
                disabled={otp.length < 4 && { backgroundImage: "blue" }}
              />
            </form>
            <p className="consult">
              Are you a Consultant?{" "}
              <Link to={"/become-consultant"}>Become a Partner</Link>
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <div className="right_login">
            <p>
              <div className="column">
                <h3 className="no-puck text-white">
                  {" "}
                  Trust
                  <span className="highlight"> CHOWNK </span>
                  to navigate the complexities of international immigration
                  seamlessly, ensuring you're well-informed and supported every
                  step of the way.{" "}
                </h3>
                <div className="mob video-demonstration">
                  <div
                    className="youtube-video"
                    data-lumberjack-action="partnerships.landing_page.video"
                  ></div>
                </div>
                <ul className="bullet-list">
                  <li>Secure Video 1 to 1 Call with Experts</li>
                  <li>Chat and Messaging</li>
                  <li>Recording Options</li>
                  <li>Document Checklist</li>
                  <li>Client Portal</li>
                  <li>Informational Content</li>
                  <li>Document Sharing</li>
                  <li>Feedback and Review System</li>
                  <li>Notification Alerts</li>
                </ul>
                <div className="become-partner-container mob">
                  <p>
                    <i className="bi bi-arrow-left"></i>{" "}
                    <strong>Join Now</strong>
                  </p>
                </div>
              </div>
            </p>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};
export default StudentOtp;
